<template>
    <div class="relative">
        <select v-model="selectValue" @change="onChange" required class="block appearance-none w-full bg-white border border-gray-200 text-gray-700 px-2 py-1 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
            <option :value="null" v-if="nullLabel">{{ nullLabel }}</option>
            <option v-for="(option, index) in options" :key="index" :value="valueKey?option[valueKey]:option">{{ labelKey?option[labelKey]:option }}</option>

        </select>
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: "select-dropdown",
        props: {
            nullLabel: {
                type: String,
                default: "Make Selection"
            },

            options: {
                type: Array,
                default: function(){
                    []
                }
            },

            valueKey: {
                type: String,
                default: ""
            },

            labelKey: {
                type: String,
                default: ""
            },

            value: {
                required: false,
                default: null
            }
        },

        data: function(){
            return {
                selectValue: null
            }
        },

        methods: {
            onChange: function(){
                this.$emit('input', this.selectValue)
            }
        }
    }
</script>

<style scoped>

</style>